/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import localForage from 'localforage';
import { basePathWebService } from '../constants';
import { cacheKey } from '../Contexts/loginWrapper';
export class ApiClientBase {
  baseApiUrl: string = basePathWebService;

  protected async transformOptions(options: RequestInit): Promise<RequestInit> {
    const cachedLogin = await localForage.getItem<any>(cacheKey);
    const token = cachedLogin?.jwtToken || '';
    options.headers = { ...options.headers, authorization: `Bearer ${token}` };
    options.credentials = env === 'production' ? 'same-origin' : 'include';
    return Promise.resolve(options);
  }

  protected async transformResult(_url: string, response: Response, processor: (response: Response) => any) {
    return processor(response);
  }

  protected getBaseUrl(_defaultUrl: string, _baseUrl?: string) {
    return this.baseApiUrl;
  }
}

export class AuditNotesClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  getAuditNotes(companyId?: number | undefined): Promise<AuditNotes> {
    let url_ = this.baseUrl + '/api/AuditNotes/GetAuditNotes?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAuditNotes(_response));
      });
  }

  protected processGetAuditNotes(response: Response): Promise<AuditNotes> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <AuditNotes>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AuditNotes>(<any>null);
  }

  setAuditNotes(data: AuditNotes): Promise<void> {
    let url_ = this.baseUrl + '/api/AuditNotes/SetAuditNotes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetAuditNotes(_response));
      });
  }

  protected processSetAuditNotes(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class AuditorProfileClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  getMyProfile(): Promise<UserAccountAuditor> {
    let url_ = this.baseUrl + '/api/AuditorProfile/GetMyProfile';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetMyProfile(_response));
      });
  }

  protected processGetMyProfile(response: Response): Promise<UserAccountAuditor> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountAuditor>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountAuditor>(<any>null);
  }

  setUserAccount(data: UserAccountAuditor): Promise<void> {
    let url_ = this.baseUrl + '/api/AuditorProfile/SetUserAccount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetUserAccount(_response));
      });
  }

  protected processSetUserAccount(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllCertificationCenters(): Promise<CertificationCenter[]> {
    let url_ = this.baseUrl + '/api/AuditorProfile/GetAllCertificationCenters';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllCertificationCenters(_response)
        );
      });
  }

  protected processGetAllCertificationCenters(response: Response): Promise<CertificationCenter[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CertificationCenter[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CertificationCenter[]>(<any>null);
  }
}

export class CompanyProfileClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  getMyProfile(): Promise<UserAccountCompany> {
    let url_ = this.baseUrl + '/api/CompanyProfile/GetMyProfile';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetMyProfile(_response));
      });
  }

  protected processGetMyProfile(response: Response): Promise<UserAccountCompany> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountCompany>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountCompany>(<any>null);
  }

  setUserAccount(data: UserAccountCompany): Promise<void> {
    let url_ = this.baseUrl + '/api/CompanyProfile/SetUserAccount';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetUserAccount(_response));
      });
  }

  protected processSetUserAccount(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  assignCompanyTypes(companyTypeIds: number[]): Promise<void> {
    let url_ = this.baseUrl + '/api/CompanyProfile/AssignCompanyTypes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(companyTypeIds);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAssignCompanyTypes(_response));
      });
  }

  protected processAssignCompanyTypes(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllCompanyTypes(): Promise<CompanyType[]> {
    let url_ = this.baseUrl + '/api/CompanyProfile/GetAllCompanyTypes';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCompanyTypes(_response));
      });
  }

  protected processGetAllCompanyTypes(response: Response): Promise<CompanyType[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CompanyType[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CompanyType[]>(<any>null);
  }
}

export class GraphicClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  setGraphicAssignment(data: GraphicAssignment[]): Promise<void> {
    let url_ = this.baseUrl + '/api/Graphic/SetGraphicAssignment';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetGraphicAssignment(_response));
      });
  }

  protected processSetGraphicAssignment(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getGraphicAssignments(): Promise<GraphicAssignment[]> {
    let url_ = this.baseUrl + '/api/Graphic/GetGraphicAssignments';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetGraphicAssignments(_response));
      });
  }

  protected processGetGraphicAssignments(response: Response): Promise<GraphicAssignment[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <GraphicAssignment[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GraphicAssignment[]>(<any>null);
  }

  getGraphicResultData(): Promise<GraphicalResultCategory[]> {
    let url_ = this.baseUrl + '/api/Graphic/GetGraphicResultData';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetGraphicResultData(_response));
      });
  }

  protected processGetGraphicResultData(response: Response): Promise<GraphicalResultCategory[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <GraphicalResultCategory[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GraphicalResultCategory[]>(<any>null);
  }

  getGraphicResultDataForStar(starId?: number | undefined): Promise<GraphicalResultCategory[]> {
    let url_ = this.baseUrl + '/api/Graphic/GetGraphicResultDataForStar?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetGraphicResultDataForStar(_response)
        );
      });
  }

  protected processGetGraphicResultDataForStar(response: Response): Promise<GraphicalResultCategory[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <GraphicalResultCategory[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<GraphicalResultCategory[]>(<any>null);
  }
}

export class QuestionClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  addQuestion(data: Question): Promise<number> {
    let url_ = this.baseUrl + '/api/Question/AddQuestion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAddQuestion(_response));
      });
  }

  protected processAddQuestion(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(<any>null);
  }

  deleteQuestion(questionId?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeleteQuestion?';
    if (questionId === null) throw new Error("The parameter 'questionId' cannot be null.");
    else if (questionId !== undefined) url_ += 'questionId=' + encodeURIComponent('' + questionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeleteQuestion(_response));
      });
  }

  protected processDeleteQuestion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  updateQuestion(data: Question): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/UpdateQuestion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUpdateQuestion(_response));
      });
  }

  protected processUpdateQuestion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllQuestionsForOverview(): Promise<Question[]> {
    let url_ = this.baseUrl + '/api/Question/GetAllQuestionsForOverview';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllQuestionsForOverview(_response)
        );
      });
  }

  protected processGetAllQuestionsForOverview(response: Response): Promise<Question[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Question[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Question[]>(<any>null);
  }

  getAllQuestionsSlim(): Promise<Question[]> {
    let url_ = this.baseUrl + '/api/Question/GetAllQuestionsSlim';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllQuestionsSlim(_response));
      });
  }

  protected processGetAllQuestionsSlim(response: Response): Promise<Question[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Question[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Question[]>(<any>null);
  }

  getQuestionsForStar(data: QuestionsForStarRequest): Promise<Question[]> {
    let url_ = this.baseUrl + '/api/Question/GetQuestionsForStar';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetQuestionsForStar(_response));
      });
  }

  protected processGetQuestionsForStar(response: Response): Promise<Question[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Question[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Question[]>(<any>null);
  }

  getAvailabeDocuments(): Promise<QuestionDocument[]> {
    let url_ = this.baseUrl + '/api/Question/GetAvailabeDocuments';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailabeDocuments(_response));
      });
  }

  protected processGetAvailabeDocuments(response: Response): Promise<QuestionDocument[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <QuestionDocument[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionDocument[]>(<any>null);
  }

  getQuestionAspects(): Promise<QuestionAspect[]> {
    let url_ = this.baseUrl + '/api/Question/GetQuestionAspects';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetQuestionAspects(_response));
      });
  }

  protected processGetQuestionAspects(response: Response): Promise<QuestionAspect[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <QuestionAspect[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionAspect[]>(<any>null);
  }

  getQuestionCrossReferences(): Promise<QuestionCrossReference[]> {
    let url_ = this.baseUrl + '/api/Question/GetQuestionCrossReferences';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetQuestionCrossReferences(_response)
        );
      });
  }

  protected processGetQuestionCrossReferences(response: Response): Promise<QuestionCrossReference[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <QuestionCrossReference[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionCrossReference[]>(<any>null);
  }

  getUsedQuestionCrossReferenceIds(): Promise<number[]> {
    let url_ = this.baseUrl + '/api/Question/GetUsedQuestionCrossReferenceIds';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetUsedQuestionCrossReferenceIds(_response)
        );
      });
  }

  protected processGetUsedQuestionCrossReferenceIds(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(<any>null);
  }

  getUsedQuestionAspectIds(): Promise<number[]> {
    let url_ = this.baseUrl + '/api/Question/GetUsedQuestionAspectIds';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedQuestionAspectIds(_response));
      });
  }

  protected processGetUsedQuestionAspectIds(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(<any>null);
  }

  getUsedQuestionCategoryIds(): Promise<number[]> {
    let url_ = this.baseUrl + '/api/Question/GetUsedQuestionCategoryIds';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetUsedQuestionCategoryIds(_response)
        );
      });
  }

  protected processGetUsedQuestionCategoryIds(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(<any>null);
  }

  getQuestionCategories(): Promise<QuestionCategory[]> {
    let url_ = this.baseUrl + '/api/Question/GetQuestionCategories';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetQuestionCategories(_response));
      });
  }

  protected processGetQuestionCategories(response: Response): Promise<QuestionCategory[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <QuestionCategory[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<QuestionCategory[]>(<any>null);
  }

  sortQuestions(data: Question[]): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/SortQuestions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSortQuestions(_response));
      });
  }

  protected processSortQuestions(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setQuestionCategories(data: QuestionCategory[]): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/SetQuestionCategories';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetQuestionCategories(_response));
      });
  }

  protected processSetQuestionCategories(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  deactivateQuestionCategory(data: QuestionRelatedItemDeactivateRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeactivateQuestionCategory';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeactivateQuestionCategory(_response)
        );
      });
  }

  protected processDeactivateQuestionCategory(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setQuestionAspects(data: QuestionAspect[]): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/SetQuestionAspects';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetQuestionAspects(_response));
      });
  }

  protected processSetQuestionAspects(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  deactivateQuestionAspect(data: QuestionRelatedItemDeactivateRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeactivateQuestionAspect';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeactivateQuestionAspect(_response));
      });
  }

  protected processDeactivateQuestionAspect(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setQuestionCrossReferences(data: QuestionCrossReference[]): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/SetQuestionCrossReferences';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSetQuestionCrossReferences(_response)
        );
      });
  }

  protected processSetQuestionCrossReferences(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getCrossReferenceIcons(): Promise<string[]> {
    let url_ = this.baseUrl + '/api/Question/GetCrossReferenceIcons';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCrossReferenceIcons(_response));
      });
  }

  protected processGetCrossReferenceIcons(response: Response): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string[]>(<any>null);
  }

  deactivateQuestionCrossReference(data: QuestionRelatedItemDeactivateRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeactivateQuestionCrossReference';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeactivateQuestionCrossReference(_response)
        );
      });
  }

  protected processDeactivateQuestionCrossReference(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  deleteQuestionCrossReference(id?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeleteQuestionCrossReference?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteQuestionCrossReference(_response)
        );
      });
  }

  protected processDeleteQuestionCrossReference(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  deleteQuestionAspect(id?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeleteQuestionAspect?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeleteQuestionAspect(_response));
      });
  }

  protected processDeleteQuestionAspect(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  deleteQuestionCategory(id?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Question/DeleteQuestionCategory?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeleteQuestionCategory(_response));
      });
  }

  protected processDeleteQuestionCategory(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getQuestionById(questionId?: number | undefined): Promise<Question> {
    let url_ = this.baseUrl + '/api/Question/GetQuestionById?';
    if (questionId === null) throw new Error("The parameter 'questionId' cannot be null.");
    else if (questionId !== undefined) url_ += 'questionId=' + encodeURIComponent('' + questionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetQuestionById(_response));
      });
  }

  protected processGetQuestionById(response: Response): Promise<Question> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Question>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Question>(<any>null);
  }
}

export class ReportClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  setLayout(data?: CompanyReportLayout | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetLayout?';
    if (data === null) throw new Error("The parameter 'data' cannot be null.");
    else if (data !== undefined) url_ += 'data=' + encodeURIComponent('' + data) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetLayout(_response));
      });
  }

  protected processSetLayout(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setLayoutAdmin(companyId?: number | undefined, data?: CompanyReportLayout | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetLayoutAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    if (data === null) throw new Error("The parameter 'data' cannot be null.");
    else if (data !== undefined) url_ += 'data=' + encodeURIComponent('' + data) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetLayoutAdmin(_response));
      });
  }

  protected processSetLayoutAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getLayout(): Promise<CompanyReportLayout> {
    let url_ = this.baseUrl + '/api/Report/GetLayout';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetLayout(_response));
      });
  }

  protected processGetLayout(response: Response): Promise<CompanyReportLayout> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CompanyReportLayout>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CompanyReportLayout>(<any>null);
  }

  getLayoutAdmin(companyId?: number | undefined): Promise<CompanyReportLayout> {
    let url_ = this.baseUrl + '/api/Report/GetLayoutAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetLayoutAdmin(_response));
      });
  }

  protected processGetLayoutAdmin(response: Response): Promise<CompanyReportLayout> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CompanyReportLayout>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CompanyReportLayout>(<any>null);
  }

  setPredefinedCoverImage(id?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetPredefinedCoverImage?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetPredefinedCoverImage(_response));
      });
  }

  protected processSetPredefinedCoverImage(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setPredefinedCoverImageAdmin(companyId?: number | undefined, id?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetPredefinedCoverImageAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSetPredefinedCoverImageAdmin(_response)
        );
      });
  }

  protected processSetPredefinedCoverImageAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setCustomCoverImage(used?: boolean | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetCustomCoverImage?';
    if (used === null) throw new Error("The parameter 'used' cannot be null.");
    else if (used !== undefined) url_ += 'used=' + encodeURIComponent('' + used) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCustomCoverImage(_response));
      });
  }

  protected processSetCustomCoverImage(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setCustomCoverImageAdmin(companyId?: number | undefined, used?: boolean | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetCustomCoverImageAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    if (used === null) throw new Error("The parameter 'used' cannot be null.");
    else if (used !== undefined) url_ += 'used=' + encodeURIComponent('' + used) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCustomCoverImageAdmin(_response));
      });
  }

  protected processSetCustomCoverImageAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  uploadCoverImage(body?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/UploadCoverImage';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (body !== null && body !== undefined) content_.append('body', body.data, body.fileName ? body.fileName : 'body');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUploadCoverImage(_response));
      });
  }

  protected processUploadCoverImage(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  uploadCoverImageAdmin(companyId?: number | undefined, body?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/UploadCoverImageAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (body !== null && body !== undefined) content_.append('body', body.data, body.fileName ? body.fileName : 'body');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUploadCoverImageAdmin(_response));
      });
  }

  protected processUploadCoverImageAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getCustomCoverImage(): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Report/GetCustomCoverImage';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomCoverImage(_response));
      });
  }

  protected processGetCustomCoverImage(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  getCustomCoverImageAdmin(companyId?: number | undefined): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Report/GetCustomCoverImageAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomCoverImageAdmin(_response));
      });
  }

  protected processGetCustomCoverImageAdmin(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  getCoverImage(): Promise<ReportCoverImage> {
    let url_ = this.baseUrl + '/api/Report/GetCoverImage';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCoverImage(_response));
      });
  }

  protected processGetCoverImage(response: Response): Promise<ReportCoverImage> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <ReportCoverImage>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReportCoverImage>(<any>null);
  }

  getCoverImageAdmin(companyId?: number | undefined): Promise<ReportCoverImage> {
    let url_ = this.baseUrl + '/api/Report/GetCoverImageAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCoverImageAdmin(_response));
      });
  }

  protected processGetCoverImageAdmin(response: Response): Promise<ReportCoverImage> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <ReportCoverImage>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ReportCoverImage>(<any>null);
  }

  uploadLogo(body?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/UploadLogo';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (body !== null && body !== undefined) content_.append('body', body.data, body.fileName ? body.fileName : 'body');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUploadLogo(_response));
      });
  }

  protected processUploadLogo(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  uploadLogoAdmin(companyId?: number | undefined, body?: FileParameter | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/UploadLogoAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (body !== null && body !== undefined) content_.append('body', body.data, body.fileName ? body.fileName : 'body');

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUploadLogoAdmin(_response));
      });
  }

  protected processUploadLogoAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getLogo(): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Report/GetLogo';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetLogo(_response));
      });
  }

  protected processGetLogo(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  getLogoAdmin(companyId?: number | undefined): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Report/GetLogoAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetLogoAdmin(_response));
      });
  }

  protected processGetLogoAdmin(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  setCompanySlogan(data?: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetCompanySlogan?';
    if (data !== undefined && data !== null) url_ += 'data=' + encodeURIComponent('' + data) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCompanySlogan(_response));
      });
  }

  protected processSetCompanySlogan(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setCompanySloganAdmin(companyId?: number | undefined, data?: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetCompanySloganAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    if (data !== undefined && data !== null) url_ += 'data=' + encodeURIComponent('' + data) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCompanySloganAdmin(_response));
      });
  }

  protected processSetCompanySloganAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getCompanySlogan(): Promise<SloganResult> {
    let url_ = this.baseUrl + '/api/Report/GetCompanySlogan';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCompanySlogan(_response));
      });
  }

  protected processGetCompanySlogan(response: Response): Promise<SloganResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <SloganResult>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SloganResult>(<any>null);
  }

  getCompanySloganAdmin(companyId?: number | undefined): Promise<SloganResult> {
    let url_ = this.baseUrl + '/api/Report/GetCompanySloganAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCompanySloganAdmin(_response));
      });
  }

  protected processGetCompanySloganAdmin(response: Response): Promise<SloganResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <SloganResult>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SloganResult>(<any>null);
  }

  getTextColor(): Promise<SloganResult> {
    let url_ = this.baseUrl + '/api/Report/GetTextColor';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetTextColor(_response));
      });
  }

  protected processGetTextColor(response: Response): Promise<SloganResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <SloganResult>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SloganResult>(<any>null);
  }

  getTextColorAdmin(companyId?: number | undefined): Promise<SloganResult> {
    let url_ = this.baseUrl + '/api/Report/GetTextColorAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetTextColorAdmin(_response));
      });
  }

  protected processGetTextColorAdmin(response: Response): Promise<SloganResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <SloganResult>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SloganResult>(<any>null);
  }

  setTextColor(data?: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetTextColor?';
    if (data !== undefined && data !== null) url_ += 'data=' + encodeURIComponent('' + data) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetTextColor(_response));
      });
  }

  protected processSetTextColor(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setTextColorAdmin(companyId?: number | undefined, data?: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Report/SetTextColorAdmin?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    if (data !== undefined && data !== null) url_ += 'data=' + encodeURIComponent('' + data) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetTextColorAdmin(_response));
      });
  }

  protected processSetTextColorAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class SigninClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  signInUser(request: SigninRequest): Promise<UserLoginViewModel> {
    let url_ = this.baseUrl + '/api/Signin/SignInUser';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSignInUser(_response));
      });
  }

  protected processSignInUser(response: Response): Promise<UserLoginViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserLoginViewModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserLoginViewModel>(<any>null);
  }

  refreshUserLogin(jwtToken?: string | null | undefined): Promise<UserLoginViewModel> {
    let url_ = this.baseUrl + '/api/Signin/RefreshUserLogin?';
    if (jwtToken !== undefined && jwtToken !== null) url_ += 'jwtToken=' + encodeURIComponent('' + jwtToken) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processRefreshUserLogin(_response));
      });
  }

  protected processRefreshUserLogin(response: Response): Promise<UserLoginViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserLoginViewModel>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserLoginViewModel>(<any>null);
  }

  setUserLoginCredentials(request: SetCredentialsRequest): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Signin/SetUserLoginCredentials';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetUserLoginCredentials(_response));
      });
  }

  protected processSetUserLoginCredentials(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  requestResetToken(request: ResetTokenRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/Signin/RequestResetToken';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processRequestResetToken(_response));
      });
  }

  protected processRequestResetToken(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  clearRefreshToken(): Promise<void> {
    let url_ = this.baseUrl + '/api/Signin/ClearRefreshToken';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processClearRefreshToken(_response));
      });
  }

  protected processClearRefreshToken(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class StarControllDataClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  saveControlData(star: Star): Promise<void> {
    let url_ = this.baseUrl + '/api/StarControllData/SaveControlData';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(star);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSaveControlData(_response));
      });
  }

  protected processSaveControlData(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class StarClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  startStar(justForIso?: boolean | undefined, sourceStarId?: number | null | undefined): Promise<number> {
    let url_ = this.baseUrl + '/api/Star/StartStar?';
    if (justForIso === null) throw new Error("The parameter 'justForIso' cannot be null.");
    else if (justForIso !== undefined) url_ += 'justForIso=' + encodeURIComponent('' + justForIso) + '&';
    if (sourceStarId !== undefined && sourceStarId !== null)
      url_ += 'sourceStarId=' + encodeURIComponent('' + sourceStarId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processStartStar(_response));
      });
  }

  protected processStartStar(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(<any>null);
  }

  setStarCompanyAnswer(data: StarCompanyAnswer): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/SetStarCompanyAnswer';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetStarCompanyAnswer(_response));
      });
  }

  protected processSetStarCompanyAnswer(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setStarCompanyAnswerForCompanyReport(data: StarCompanyAnswer): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/SetStarCompanyAnswerForCompanyReport';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSetStarCompanyAnswerForCompanyReport(_response)
        );
      });
  }

  protected processSetStarCompanyAnswerForCompanyReport(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setStarCompanyAnswerState(request: StarCompanyStateRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/SetStarCompanyAnswerState';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetStarCompanyAnswerState(_response));
      });
  }

  protected processSetStarCompanyAnswerState(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getStarCompanyAnswers(starId?: number | undefined): Promise<StarCompanyAnswer[]> {
    let url_ = this.baseUrl + '/api/Star/GetStarCompanyAnswers?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarCompanyAnswers(_response));
      });
  }

  protected processGetStarCompanyAnswers(response: Response): Promise<StarCompanyAnswer[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarCompanyAnswer[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarCompanyAnswer[]>(<any>null);
  }

  getStarCompanyPreviousAnswers(currentStarId?: number | undefined): Promise<StarCompanyAnswer[]> {
    let url_ = this.baseUrl + '/api/Star/GetStarCompanyPreviousAnswers?';
    if (currentStarId === null) throw new Error("The parameter 'currentStarId' cannot be null.");
    else if (currentStarId !== undefined) url_ += 'currentStarId=' + encodeURIComponent('' + currentStarId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetStarCompanyPreviousAnswers(_response)
        );
      });
  }

  protected processGetStarCompanyPreviousAnswers(response: Response): Promise<StarCompanyAnswer[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarCompanyAnswer[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarCompanyAnswer[]>(<any>null);
  }

  getQuestions(starId?: number | undefined): Promise<Question[]> {
    let url_ = this.baseUrl + '/api/Star/GetQuestions?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetQuestions(_response));
      });
  }

  protected processGetQuestions(response: Response): Promise<Question[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Question[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Question[]>(<any>null);
  }

  getFormDocument(fileName?: string | null | undefined): Promise<FileResponse | null> {
    let url_ = this.baseUrl + '/api/Star/GetFormDocument?';
    if (fileName !== undefined && fileName !== null) url_ += 'fileName=' + encodeURIComponent('' + fileName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/octet-stream',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetFormDocument(_response));
      });
  }

  protected processGetFormDocument(response: Response): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      return response.blob().then((blob) => {
        return { fileName: fileName, data: blob, status: status, headers: _headers };
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  getCompletedStars(): Promise<CompletedStar[]> {
    let url_ = this.baseUrl + '/api/Star/GetCompletedStars';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCompletedStars(_response));
      });
  }

  protected processGetCompletedStars(response: Response): Promise<CompletedStar[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CompletedStar[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CompletedStar[]>(<any>null);
  }

  setAvailableForAudit(starId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/SetAvailableForAudit';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(starId);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetAvailableForAudit(_response));
      });
  }

  protected processSetAvailableForAudit(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setCompanyReportDone(starId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/SetCompanyReportDone';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(starId);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCompanyReportDone(_response));
      });
  }

  protected processSetCompanyReportDone(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getCompanyOverview(): Promise<Star[]> {
    let url_ = this.baseUrl + '/api/Star/GetCompanyOverview';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCompanyOverview(_response));
      });
  }

  protected processGetCompanyOverview(response: Response): Promise<Star[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Star[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Star[]>(<any>null);
  }

  getAuditorOverview(editedStars: StarAuditorOverviewEdited[]): Promise<StarAuditorOverviewItem[]> {
    let url_ = this.baseUrl + '/api/Star/GetAuditorOverview';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(editedStars);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAuditorOverview(_response));
      });
  }

  protected processGetAuditorOverview(response: Response): Promise<StarAuditorOverviewItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarAuditorOverviewItem[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarAuditorOverviewItem[]>(<any>null);
  }

  getStarAuditorOverviewItemForAdmin(starId?: number | undefined): Promise<StarAuditorOverviewItem> {
    let url_ = this.baseUrl + '/api/Star/GetStarAuditorOverviewItemForAdmin?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetStarAuditorOverviewItemForAdmin(_response)
        );
      });
  }

  protected processGetStarAuditorOverviewItemForAdmin(response: Response): Promise<StarAuditorOverviewItem> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarAuditorOverviewItem>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarAuditorOverviewItem>(<any>null);
  }

  getAllStars(): Promise<Star[]> {
    let url_ = this.baseUrl + '/api/Star/GetAllStars';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllStars(_response));
      });
  }

  protected processGetAllStars(response: Response): Promise<Star[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <Star[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Star[]>(<any>null);
  }

  isStarAuditAvailabe(starId?: number | undefined): Promise<boolean> {
    let url_ = this.baseUrl + '/api/Star/IsStarAuditAvailabe?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processIsStarAuditAvailabe(_response));
      });
  }

  protected processIsStarAuditAvailabe(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(<any>null);
  }

  setStarAuditorAnswer(data: StarAuditorAnswer): Promise<number> {
    let url_ = this.baseUrl + '/api/Star/SetStarAuditorAnswer';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetStarAuditorAnswer(_response));
      });
  }

  protected processSetStarAuditorAnswer(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(<any>null);
  }

  setStarAuditorAnswers(data: StarAuditorAnswer[]): Promise<number[]> {
    let url_ = this.baseUrl + '/api/Star/SetStarAuditorAnswers';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetStarAuditorAnswers(_response));
      });
  }

  protected processSetStarAuditorAnswers(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(<any>null);
  }

  startStarAudit(star: Star): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/StartStarAudit';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(star);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processStartStarAudit(_response));
      });
  }

  protected processStartStarAudit(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  endStar(starId?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/EndStar?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processEndStar(_response));
      });
  }

  protected processEndStar(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getStarAdminOverviewItems(): Promise<AdminOverviewItem[]> {
    let url_ = this.baseUrl + '/api/Star/GetStarAdminOverviewItems';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarAdminOverviewItems(_response));
      });
  }

  protected processGetStarAdminOverviewItems(response: Response): Promise<AdminOverviewItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <AdminOverviewItem[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<AdminOverviewItem[]>(<any>null);
  }

  getStarAdminControlData(starId?: number | undefined): Promise<StarOverviewItem> {
    let url_ = this.baseUrl + '/api/Star/GetStarAdminControlData?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarAdminControlData(_response));
      });
  }

  protected processGetStarAdminControlData(response: Response): Promise<StarOverviewItem> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarOverviewItem>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarOverviewItem>(<any>null);
  }

  getStarAdminOverviewItem(starId?: number | undefined): Promise<StarOverviewItem> {
    let url_ = this.baseUrl + '/api/Star/GetStarAdminOverviewItem?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarAdminOverviewItem(_response));
      });
  }

  protected processGetStarAdminOverviewItem(response: Response): Promise<StarOverviewItem> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarOverviewItem>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarOverviewItem>(<any>null);
  }

  getStarVersion(starId?: number | undefined): Promise<StarVersion> {
    let url_ = this.baseUrl + '/api/Star/GetStarVersion?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarVersion(_response));
      });
  }

  protected processGetStarVersion(response: Response): Promise<StarVersion> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarVersion>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarVersion>(<any>null);
  }

  setStarArchived(starId?: number | undefined, archived?: boolean | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Star/SetStarArchived?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    if (archived === null) throw new Error("The parameter 'archived' cannot be null.");
    else if (archived !== undefined) url_ += 'archived=' + encodeURIComponent('' + archived) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetStarArchived(_response));
      });
  }

  protected processSetStarArchived(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getArchivedStarIds(): Promise<number[]> {
    let url_ = this.baseUrl + '/api/Star/GetArchivedStarIds';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedStarIds(_response));
      });
  }

  protected processGetArchivedStarIds(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(<any>null);
  }

  getArchivedStarItems(): Promise<ArchivedStarItem[]> {
    let url_ = this.baseUrl + '/api/Star/GetArchivedStarItems';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedStarItems(_response));
      });
  }

  protected processGetArchivedStarItems(response: Response): Promise<ArchivedStarItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <ArchivedStarItem[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ArchivedStarItem[]>(<any>null);
  }

  getArchivedStarItemsAdmin(): Promise<ArchivedStarItem[]> {
    let url_ = this.baseUrl + '/api/Star/GetArchivedStarItemsAdmin';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetArchivedStarItemsAdmin(_response));
      });
  }

  protected processGetArchivedStarItemsAdmin(response: Response): Promise<ArchivedStarItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <ArchivedStarItem[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ArchivedStarItem[]>(<any>null);
  }

  getStarCompanyReportData(starId?: number | undefined): Promise<StarCompanyReportData> {
    let url_ = this.baseUrl + '/api/Star/GetStarCompanyReportData?';
    if (starId === null) throw new Error("The parameter 'starId' cannot be null.");
    else if (starId !== undefined) url_ += 'starId=' + encodeURIComponent('' + starId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarCompanyReportData(_response));
      });
  }

  protected processGetStarCompanyReportData(response: Response): Promise<StarCompanyReportData> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarCompanyReportData>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarCompanyReportData>(<any>null);
  }
}

export class StarVersionClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  publishStarVersion(title?: string | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/StarVersion/PublishStarVersion?';
    if (title !== undefined && title !== null) url_ += 'title=' + encodeURIComponent('' + title) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processPublishStarVersion(_response));
      });
  }

  protected processPublishStarVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllStarVersions(): Promise<StarVersion[]> {
    let url_ = this.baseUrl + '/api/StarVersion/GetAllStarVersions';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllStarVersions(_response));
      });
  }

  protected processGetAllStarVersions(response: Response): Promise<StarVersion[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarVersion[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarVersion[]>(<any>null);
  }

  getStarVersionsOverView(): Promise<StarVersionOverItem[]> {
    let url_ = this.baseUrl + '/api/StarVersion/GetStarVersionsOverView';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarVersionsOverView(_response));
      });
  }

  protected processGetStarVersionsOverView(response: Response): Promise<StarVersionOverItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarVersionOverItem[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarVersionOverItem[]>(<any>null);
  }

  deleteStarVersion(versionId?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/StarVersion/DeleteStarVersion?';
    if (versionId === null) throw new Error("The parameter 'versionId' cannot be null.");
    else if (versionId !== undefined) url_ += 'versionId=' + encodeURIComponent('' + versionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeleteStarVersion(_response));
      });
  }

  protected processDeleteStarVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  assignStarVersion(versionId?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/StarVersion/AssignStarVersion?';
    if (versionId === null) throw new Error("The parameter 'versionId' cannot be null.");
    else if (versionId !== undefined) url_ += 'versionId=' + encodeURIComponent('' + versionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAssignStarVersion(_response));
      });
  }

  protected processAssignStarVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getStarVersionQuestions(versionId?: number | undefined): Promise<StarVersionQuestion[]> {
    let url_ = this.baseUrl + '/api/StarVersion/GetStarVersionQuestions?';
    if (versionId === null) throw new Error("The parameter 'versionId' cannot be null.");
    else if (versionId !== undefined) url_ += 'versionId=' + encodeURIComponent('' + versionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarVersionQuestions(_response));
      });
  }

  protected processGetStarVersionQuestions(response: Response): Promise<StarVersionQuestion[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarVersionQuestion[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarVersionQuestion[]>(<any>null);
  }

  getAvailableQuestions(): Promise<StarVersionQuestion[]> {
    let url_ = this.baseUrl + '/api/StarVersion/GetAvailableQuestions';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAvailableQuestions(_response));
      });
  }

  protected processGetAvailableQuestions(response: Response): Promise<StarVersionQuestion[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <StarVersionQuestion[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<StarVersionQuestion[]>(<any>null);
  }

  getStarVersionTitle(versionId?: number | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/StarVersion/GetStarVersionTitle?';
    if (versionId === null) throw new Error("The parameter 'versionId' cannot be null.");
    else if (versionId !== undefined) url_ += 'versionId=' + encodeURIComponent('' + versionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetStarVersionTitle(_response));
      });
  }

  protected processGetStarVersionTitle(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(<any>null);
  }

  saveStarVersion(request: StarVersionUpdateRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/StarVersion/SaveStarVersion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSaveStarVersion(_response));
      });
  }

  protected processSaveStarVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }
}

export class SubCompaniesClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  addSubCompany(data: SubCompany): Promise<number> {
    let url_ = this.baseUrl + '/api/SubCompanies/AddSubCompany';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAddSubCompany(_response));
      });
  }

  protected processAddSubCompany(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <number>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(<any>null);
  }

  assignSubCompanyTypes(data: SubCompanyAssignTypeRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/SubCompanies/AssignSubCompanyTypes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAssignSubCompanyTypes(_response));
      });
  }

  protected processAssignSubCompanyTypes(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  updateSubCompany(data: SubCompany): Promise<void> {
    let url_ = this.baseUrl + '/api/SubCompanies/UpdateSubCompany';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSubCompany(_response));
      });
  }

  protected processUpdateSubCompany(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  deleteSubCompany(subCompanyId?: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/SubCompanies/DeleteSubCompany?';
    if (subCompanyId === null) throw new Error("The parameter 'subCompanyId' cannot be null.");
    else if (subCompanyId !== undefined) url_ += 'subCompanyId=' + encodeURIComponent('' + subCompanyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSubCompany(_response));
      });
  }

  protected processDeleteSubCompany(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getCompanySubCompanies(): Promise<SubCompany[]> {
    let url_ = this.baseUrl + '/api/SubCompanies/GetCompanySubCompanies';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCompanySubCompanies(_response));
      });
  }

  protected processGetCompanySubCompanies(response: Response): Promise<SubCompany[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <SubCompany[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SubCompany[]>(<any>null);
  }

  getCompaniesAuditorOverview(): Promise<CompaniesStarAuditorOverview> {
    let url_ = this.baseUrl + '/api/SubCompanies/GetCompaniesAuditorOverview';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetCompaniesAuditorOverview(_response)
        );
      });
  }

  protected processGetCompaniesAuditorOverview(response: Response): Promise<CompaniesStarAuditorOverview> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : <CompaniesStarAuditorOverview>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CompaniesStarAuditorOverview>(<any>null);
  }
}

export class UserAccountsClient extends ApiClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:5001';
  }

  addAdmin(data: UserAccountAdmin): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/AddAdmin';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAddAdmin(_response));
      });
  }

  protected processAddAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  addCompany(data: UserAccountCompany): Promise<UserAccountCompany> {
    let url_ = this.baseUrl + '/api/UserAccounts/AddCompany';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAddCompany(_response));
      });
  }

  protected processAddCompany(response: Response): Promise<UserAccountCompany> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountCompany>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountCompany>(<any>null);
  }

  addAuditor(data: UserAccountAuditor): Promise<UserAccountAuditor> {
    let url_ = this.baseUrl + '/api/UserAccounts/AddAuditor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAddAuditor(_response));
      });
  }

  protected processAddAuditor(response: Response): Promise<UserAccountAuditor> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountAuditor>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountAuditor>(<any>null);
  }

  addSuperAuditor(data: UserAccountSuperAuditor): Promise<UserAccountSuperAuditor> {
    let url_ = this.baseUrl + '/api/UserAccounts/AddSuperAuditor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAddSuperAuditor(_response));
      });
  }

  protected processAddSuperAuditor(response: Response): Promise<UserAccountSuperAuditor> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountSuperAuditor>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountSuperAuditor>(<any>null);
  }

  updateAdmin(data: UserAccountAdmin): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/UpdateAdmin';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAdmin(_response));
      });
  }

  protected processUpdateAdmin(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  updateCompany(data: UserAccountCompany): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/UpdateCompany';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCompany(_response));
      });
  }

  protected processUpdateCompany(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  updateAuditor(data: UserAccountAuditor): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/UpdateAuditor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUpdateAuditor(_response));
      });
  }

  protected processUpdateAuditor(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  updateSuperAuditor(data: UserAccountSuperAuditor): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/UpdateSuperAuditor';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSuperAuditor(_response));
      });
  }

  protected processUpdateSuperAuditor(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllAdmins(): Promise<UserAccountAdmin[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllAdmins';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllAdmins(_response));
      });
  }

  protected processGetAllAdmins(response: Response): Promise<UserAccountAdmin[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountAdmin[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountAdmin[]>(<any>null);
  }

  getAllCompanies(): Promise<UserAccountCompany[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllCompanies';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCompanies(_response));
      });
  }

  protected processGetAllCompanies(response: Response): Promise<UserAccountCompany[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountCompany[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountCompany[]>(<any>null);
  }

  getCompanyById(companyId?: number | undefined): Promise<UserAccountCompany> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetCompanyById?';
    if (companyId === null) throw new Error("The parameter 'companyId' cannot be null.");
    else if (companyId !== undefined) url_ += 'companyId=' + encodeURIComponent('' + companyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetCompanyById(_response));
      });
  }

  protected processGetCompanyById(response: Response): Promise<UserAccountCompany> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountCompany>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountCompany>(<any>null);
  }

  getAllAuditors(): Promise<UserAccountAuditor[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllAuditors';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllAuditors(_response));
      });
  }

  protected processGetAllAuditors(response: Response): Promise<UserAccountAuditor[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountAuditor[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountAuditor[]>(<any>null);
  }

  getAllSuperAuditors(): Promise<UserAccountSuperAuditor[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllSuperAuditors';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllSuperAuditors(_response));
      });
  }

  protected processGetAllSuperAuditors(response: Response): Promise<UserAccountSuperAuditor[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <UserAccountSuperAuditor[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserAccountSuperAuditor[]>(<any>null);
  }

  deactivate(request: UserDeactivateRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/Deactivate';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
      });
  }

  protected processDeactivate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  delete(userLoginId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/Delete';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(userLoginId);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
      });
  }

  protected processDelete(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  requestResetToken(request: ResetTokenRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/RequestResetToken';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processRequestResetToken(_response));
      });
  }

  protected processRequestResetToken(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  assignAuditorCompanies(request: AssignAuditorCompaniesRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/AssignAuditorCompanies';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAssignAuditorCompanies(_response));
      });
  }

  protected processAssignAuditorCompanies(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  assignCompanyTypes(request: AssignCompanyTypesRequest): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/AssignCompanyTypes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processAssignCompanyTypes(_response));
      });
  }

  protected processAssignCompanyTypes(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllCompanyTypes(): Promise<CompanyType[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllCompanyTypes';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCompanyTypes(_response));
      });
  }

  protected processGetAllCompanyTypes(response: Response): Promise<CompanyType[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CompanyType[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CompanyType[]>(<any>null);
  }

  getAllCertificationCenters(): Promise<CertificationCenter[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllCertificationCenters';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllCertificationCenters(_response)
        );
      });
  }

  protected processGetAllCertificationCenters(response: Response): Promise<CertificationCenter[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <CertificationCenter[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<CertificationCenter[]>(<any>null);
  }

  setCompanyTypes(data: CompanyType[]): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/SetCompanyTypes';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCompanyTypes(_response));
      });
  }

  protected processSetCompanyTypes(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  setCertificationCenters(data: CertificationCenter[]): Promise<void> {
    let url_ = this.baseUrl + '/api/UserAccounts/SetCertificationCenters';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processSetCertificationCenters(_response));
      });
  }

  protected processSetCertificationCenters(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  getAllSubCompanies(): Promise<SubCompany[]> {
    let url_ = this.baseUrl + '/api/UserAccounts/GetAllSubCompanies';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processGetAllSubCompanies(_response));
      });
  }

  protected processGetAllSubCompanies(response: Response): Promise<SubCompany[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <SubCompany[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<SubCompany[]>(<any>null);
  }

  isDuplicate(emailAddress?: string | null | undefined): Promise<boolean> {
    let url_ = this.baseUrl + '/api/UserAccounts/IsDuplicate?';
    if (emailAddress !== undefined && emailAddress !== null)
      url_ += 'emailAddress=' + encodeURIComponent('' + emailAddress) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) => this.processIsDuplicate(_response));
      });
  }

  protected processIsDuplicate(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 = _responseText === '' ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(<any>null);
  }
}

export interface AuditNotes {
  companyId: number;
  company?: UserAccountCompany | undefined;
  notes?: string | undefined;
}

export interface UserAccountBase {
  userLoginId: number;
  userLogin?: UserLogin | undefined;
  postcode?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  state?: string | undefined;
  telephoneNumber?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
}

export interface UserAccountCompany extends UserAccountBase {
  companyTitle?: string | undefined;
  webSite?: string | undefined;
  fullTimePositions: number;
  productAccess: ProductAccess;
  companyTypeMaps?: CompanyTypeMap[] | undefined;
  starVersionId?: number | undefined;
  starVersion?: StarVersion | undefined;
  companyTypes?: CompanyType[] | undefined;
}

export enum ProductAccess {
  CseStar = 0,
  CompanyReportOnly = 1,
}

export interface CompanyTypeMap {
  companyTypeId: number;
  companyType?: CompanyType | undefined;
  userAccountCompanyId: number;
  userAccountCompany?: UserAccountCompany | undefined;
}

export interface CompanyType {
  id: number;
  title?: string | undefined;
  deactivated: boolean;
}

export interface StarVersion {
  id: number;
  title?: string | undefined;
  publishingDate: Date;
  deleted: boolean;
  questionIdsSorted?: string | undefined;
}

export interface UserLogin {
  id: number;
  emailAddress?: string | undefined;
  deactivated: boolean;
  userType: UserType;
}

export enum UserType {
  Admin = 0,
  Company = 1,
  Auditor = 2,
  SuperAuditor = 3,
}

export interface UserAccountAuditor extends UserAccountBase {
  shortForm?: string | undefined;
  certificationCenterId: number;
  certificationCenter?: CertificationCenter | undefined;
  auditorCompanies?: AuditorCompanyMap[] | undefined;
  companies?: UserAccountCompany[] | undefined;
}

export interface CertificationCenter {
  id: number;
  title?: string | undefined;
  deactivated: boolean;
}

export interface AuditorCompanyMap {
  userAccountAuditorId: number;
  userAccountAuditor?: UserAccountAuditor | undefined;
  userAccountCompanyId: number;
  userAccountCompany?: UserAccountCompany | undefined;
}

export interface GraphicAssignment {
  id: number;
  categoryId: number;
  category?: QuestionCategory | undefined;
  partId: number;
}

export interface QuestionCategory {
  id: number;
  title?: string | undefined;
  color?: string | undefined;
  deactivated: boolean;
}

export interface GraphicalResultCategory {
  categoryId: number;
  categoryColor?: string | undefined;
  categoryTitle?: string | undefined;
  procent: number;
}

export interface Question {
  id: number;
  content?: string | undefined;
  contentForCompanyReport?: string | undefined;
  cseStandard?: string | undefined;
  cseStandardChapter?: string | undefined;
  isoNormReference?: string | undefined;
  isoNorm?: string | undefined;
  hintsForCompany?: string | undefined;
  hintsForAuditor?: string | undefined;
  justForIso: boolean;
  sort: number;
  goalQuestion?: boolean | undefined;
  deleted?: boolean | undefined;
  questionCategoryId: number;
  questionCategory?: QuestionCategory | undefined;
  questionAspectId: number;
  questionAspect?: QuestionAspect | undefined;
  questionCrossReferenceMaps?: QuestionCrossReferenceMap[] | undefined;
  questionDocuments?: QuestionDocument[] | undefined;
  companyTypeMaps?: QuestionCompanyTypeMap[] | undefined;
  connectedQuestionMaps?: QuestionConnectionMap[] | undefined;
}

export interface QuestionAspect {
  id: number;
  title?: string | undefined;
  deactivated: boolean;
  questionCategoryId: number;
  questionCategory?: QuestionCategory | undefined;
}

export interface QuestionCrossReferenceMap {
  questionId: number;
  question?: Question | undefined;
  questionCrossReferenceId: number;
  questionCrossReference?: QuestionCrossReference | undefined;
  hint?: string | undefined;
}

export interface QuestionCrossReference {
  id: number;
  title?: string | undefined;
  description?: string | undefined;
  iconUrl?: string | undefined;
  deactivated: boolean;
}

export interface QuestionDocument {
  id: number;
  documentFileName?: string | undefined;
  questionId: number;
  question?: Question | undefined;
}

export interface QuestionCompanyTypeMap {
  questionId: number;
  question?: Question | undefined;
  companyTypeId: number;
  companyType?: CompanyType | undefined;
}

export interface QuestionConnectionMap {
  parentQuestionId: number;
  parentQuestion?: Question | undefined;
  childQuestionId: number;
  childQuestion?: Question | undefined;
}

export interface QuestionsForStarRequest {
  companyTypeIds?: number[] | undefined;
  justForIso: boolean;
}

export interface QuestionRelatedItemDeactivateRequest {
  id: number;
  deactivated: boolean;
}

export enum CompanyReportLayout {
  Down = 0,
  Up = 1,
}

export interface ReportCoverImage {
  customImage: boolean;
  predefinedImageId: number;
}

export interface SloganResult {
  value?: string | undefined;
}

export interface UserLoginViewModel {
  jwtToken?: string | undefined;
  displayName?: string | undefined;
  id: number;
  emailAddress?: string | undefined;
  userType: UserType;
  productAccess?: ProductAccess | undefined;
}

export interface SigninRequest {
  emailAddress?: string | undefined;
  password?: string | undefined;
  recaptchaToken?: string | undefined;
}

export interface SetCredentialsRequest {
  token?: string | undefined;
  newPassword?: string | undefined;
  recaptchaToken?: string | undefined;
}

export interface ResetTokenRequest {
  emailAddress?: string | undefined;
  recaptchaToken?: string | undefined;
}

export interface Star {
  id: number;
  justForIso: boolean;
  started: Date;
  edited: Date;
  auditAvailable?: Date | undefined;
  auditStarted?: Date | undefined;
  auditEdited?: Date | undefined;
  auditFinished?: Date | undefined;
  finished: boolean;
  archivedAnswers?: string | undefined;
  archived?: boolean | undefined;
  starVersionId?: number | undefined;
  justCompanyReport: boolean;
  companyReportDone?: Date | undefined;
  starVersion?: StarVersion | undefined;
  companyId?: number | undefined;
  company?: UserAccountCompany | undefined;
  starControlDataId?: number | undefined;
  starControlData?: StarControlData | undefined;
  auditorId?: number | undefined;
  auditor?: UserAccountAuditor | undefined;
  previousStarId?: number | undefined;
  previousStar?: Star | undefined;
}

export interface StarControlData {
  id: number;
  ceoName?: string | undefined;
  contactPersonName?: string | undefined;
  enviromentResponsibleName?: string | undefined;
  accompanyingPersonName?: string | undefined;
  lastAuditDate?: Date | undefined;
  auditType: AuditType;
  otherAuditTypeName?: string | undefined;
  previousCorrectionsDone?: boolean | undefined;
  previousCorrectionsNotRequested: boolean;
  previousCorrectionsNotDone?: string | undefined;
  previousImprovementsDone?: boolean | undefined;
  previousImprovementsNotRequested: boolean;
  previousImprovementsNotDone?: string | undefined;
  immediateProcessing: boolean;
  immediateProcessingReason?: string | undefined;
  notesForNextAudit?: string | undefined;
  resolvedProblems?: ResolvedProblem[] | undefined;
}

export enum AuditType {
  FirstTime = 0,
  Inspection = 1,
  Recertification = 2,
  Other = 3,
}

export interface ResolvedProblem {
  id: number;
  starControlDataId: number;
  questionId: number;
  observation: boolean;
  comunication: boolean;
  documentation: boolean;
  content?: string | undefined;
}

export interface StarCompanyAnswer {
  id: number;
  content?: string | undefined;
  reportText?: string | undefined;
  starId: number;
  star?: Star | undefined;
  questionId: number;
  question?: Question | undefined;
  answerState: AnswerState;
  starAuditorAnswer?: StarAuditorAnswer | undefined;
}

export enum AnswerState {
  NotAnswered = 0,
  InProgress = 1,
  Answered = 2,
}

export interface StarAuditorAnswer {
  id: number;
  companyAnswerId: number;
  auditReportText?: string | undefined;
  improvements?: string | undefined;
  problems?: string | undefined;
  observation: boolean;
  comunication: boolean;
  documentation: boolean;
  important: boolean;
  notRelevant: boolean;
  auditResult: AuditResult;
  starCompanyAnswer?: StarCompanyAnswer | undefined;
}

export enum AuditResult {
  None = 0,
  Completed = 1,
  PartiallyCompleted = 2,
  NotCompleted = 4,
  NotAudited = 8,
}

export interface StarCompanyStateRequest {
  answerId: number;
  answerState: AnswerState;
}

export interface CompletedStar {
  id: number;
  justForIso: boolean;
  started: Date;
}

export interface StarAuditorOverviewItem {
  id: number;
  started: Date;
  edited: Date;
  auditAvailable?: Date | undefined;
  auditStarted?: Date | undefined;
  auditEdited?: Date | undefined;
  auditFinished?: Date | undefined;
  companyId: number;
  auditorName?: string | undefined;
  starVersion?: string | undefined;
  previousStar?: StarAuditorOverviewPreviousItem | undefined;
  starControlData?: StarControlData | undefined;
  starCompanyAnswers?: StarAuditorOverViewCompanyAnswer[] | undefined;
  finished: boolean;
}

export interface StarAuditorOverviewPreviousItem {
  id?: number | undefined;
  answers?: StarAuditorOverViewCompanyAnswer[] | undefined;
}

export interface StarAuditorOverViewCompanyAnswer {
  id: number;
  content?: string | undefined;
  reportText?: string | undefined;
  questionId: number;
  question?: StarAuditorOverviewQuestion | undefined;
  answerState: AnswerState;
  starAuditorAnswer?: StarAuditorOverviewStarAuditorAnswer | undefined;
}

export interface StarAuditorOverviewQuestion {
  id: number;
  content?: string | undefined;
  cseStandard?: string | undefined;
  cseStandardChapter?: string | undefined;
  isoNormReference?: string | undefined;
  isoNorm?: string | undefined;
  hintsForCompany?: string | undefined;
  hintsForAuditor?: string | undefined;
  justForIso: boolean;
  sort: number;
  goalQuestion?: boolean | undefined;
  questionAspect?: QuestionAspect | undefined;
  questionCrossReferenceMaps?: StarAuditorOverviewItemQuestionCrossReferenceMap[] | undefined;
  questionDocuments?: StarAuditorOverviewQuestionDocument[] | undefined;
  connectedQuestionMaps?: StarAuditorOverviewQuestionConnectionMap[] | undefined;
}

export interface StarAuditorOverviewItemQuestionCrossReferenceMap {
  questionId: number;
  questionCrossReferenceId: number;
  questionCrossReference?: QuestionCrossReference | undefined;
  hint?: string | undefined;
}

export interface StarAuditorOverviewQuestionDocument {
  id: number;
  documentFileName?: string | undefined;
}

export interface StarAuditorOverviewQuestionConnectionMap {
  parentQuestionId: number;
  childQuestionId: number;
}

export interface StarAuditorOverviewStarAuditorAnswer {
  id: number;
  companyAnswerId: number;
  auditReportText?: string | undefined;
  improvements?: string | undefined;
  problems?: string | undefined;
  observation: boolean;
  comunication: boolean;
  documentation: boolean;
  important: boolean;
  notRelevant: boolean;
  auditResult: AuditResult;
}

export interface StarAuditorOverviewEdited {
  starId: number;
  edited?: Date | undefined;
}

export interface AdminOverviewItem {
  id: number;
  company?: UserAccountCompany | undefined;
  starControlData?: StarControlData | undefined;
  started: Date;
  edited: Date;
  auditAvailable?: Date | undefined;
  auditStarted?: Date | undefined;
  auditEdited?: Date | undefined;
  auditFinished?: Date | undefined;
  companyReportDone?: Date | undefined;
  finished: boolean;
  auditorFullName?: string | undefined;
  starVersion?: string | undefined;
  justCompanyReport: boolean;
}

export interface StarOverviewItem {
  star?: Star | undefined;
  starCompanyAnswers?: StarCompanyAnswer[] | undefined;
}

export interface ArchivedStarItem {
  id: number;
  company?: string | undefined;
  starControlData?: StarControlData | undefined;
  started: Date;
  auditAvailable?: Date | undefined;
  auditStarted?: Date | undefined;
  auditFinished?: Date | undefined;
  auditorFullName?: string | undefined;
  starVersion?: string | undefined;
}

export interface StarCompanyReportData {
  star?: Star | undefined;
  starCompanyAnswers?: StarCompanyAnswer[] | undefined;
}

export interface StarVersionOverItem {
  id: number;
  title?: string | undefined;
  publishingDate: Date;
  countOfCompaniesOnThisVersion: number;
  countOfStarsUsingThisVersion: number;
}

export interface StarVersionQuestion {
  id: number;
  sort: number;
  content?: string | undefined;
  category?: string | undefined;
  deleted: boolean;
}

export interface StarVersionUpdateRequest {
  id: number;
  questionIdsSorted?: string | undefined;
  title?: string | undefined;
}

export interface SubCompany {
  id: number;
  parentCompanyId: number;
  emailAddress?: string | undefined;
  postcode?: string | undefined;
  city?: string | undefined;
  street?: string | undefined;
  state?: string | undefined;
  telephoneNumber?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  companyTitle?: string | undefined;
  webSite?: string | undefined;
  companyTypeMaps?: SubCompanyTypeMap[] | undefined;
  companyTypes?: CompanyType[] | undefined;
}

export interface SubCompanyTypeMap {
  companyTypeId: number;
  companyType?: CompanyType | undefined;
  subCompanyId: number;
  subCompany?: SubCompany | undefined;
}

export interface SubCompanyAssignTypeRequest {
  subCompanyId: number;
  companyTypeIds?: number[] | undefined;
}

export interface CompaniesStarAuditorOverview {
  companies?: UserAccountCompany[] | undefined;
  subCompanies?: SubCompany[] | undefined;
}

export interface UserAccountAdmin extends UserAccountBase {}

export interface UserAccountSuperAuditor extends UserAccountBase {}

export interface UserDeactivateRequest {
  userLoginId: number;
  deactivate: boolean;
}

export interface AssignAuditorCompaniesRequest {
  userAccountAuditorId: number;
  userAccountCompanyIds?: number[] | undefined;
}

export interface AssignCompanyTypesRequest {
  userAccountCompanyId: number;
  companyTypes?: number[] | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

const env = process.env.NODE_ENV;
